import { Box } from '@mui/material';
import LetterAvatar from '../LetterAvatar/LetterAvatar';

export interface IAvatarProps {
  firstName: string;
  profilePic: string;
  lastName?: string;
}
const Avatar = ({ firstName, lastName, profilePic }: IAvatarProps) => (
  <Box>
    {profilePic && (
      <img
        src={`${process.env.REACT_APP_MEDIA_FILES_BASE_URL}/${profilePic}`}
        alt="user"
        width={20}
        height={20}
        style={{ borderRadius: '50%', objectFit: 'cover' }}
      />
    )}
    {!profilePic && <LetterAvatar firstName={firstName} lastName={lastName || ''} size={20} />}
  </Box>
);

export default Avatar;
